<template>
  <section id="confirm-page-section" class="section-scc-portal container">
    <div v-if="show">
      <section id="main-document" class="section-scc-portal container"  v-if = "successful">
        <div>
          <p class="p-confirm-page">Thank you for confirming your appointment!</p>
        </div>
      </section>
      <section id="error-message" class="section-scc-portal container" v-else>
        <div>
          <p class="p-confirm-page">Appointment confirmation unfortunately failed.</p>
          <p class="p-confirm-page">Please contact donor center at  <span v-html="phone"></span></p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import {mapState} from "vuex";
export default {
  name: "appointmentConformationPage",
  data() {
    return {
      show: false,
      successful: false,
    }
  },
  computed : {
    ...mapState({
      phone: state => state.settingsAndCustomize.siteCustomizationData.headerFooter.phone,
    })
  },
  async mounted(){
    const urlParams = new URLSearchParams(window.location.search);
    const apptId = urlParams.get('apptId');
    var dataRequest = {
      action: 'entryPoints',
      entryPoint: 'appointment_calendar',
      entryAction: 'bookingConfirm',
      apptId:apptId,
    };
    const res = await this.$store.dispatch('pages/SET_entryPoint', dataRequest)
    if(res?.data?.result.confirmedForPortal){
      this.successful = true;
    }
    this.show = true;
  },
}
</script>

<style scoped>
  p {
    font-size: 1.2em;
  }
</style>
